<div class="subscription-details-container" 
[class.pro-commission-background]="currentTier === 'tier2' && isCommission" 
[class.pro-no-commission-background]="currentTier === 'tier2' && !isCommission"
[class.premium-commission-background]="currentTier === 'tier1' && isCommission"
[class.premium-no-commission-background]="currentTier === 'tier1' && !isCommission"
[class.basic-background]="currentTier === 'tier0'"
[class.mobile-view]="mode === 'bottomsheet'">
    <!-- Close button (mobile only) -->
    <button *ngIf="mode === 'bottomsheet'" class="close-btn" (click)="close()">
        <i class="pi pi-times"></i>
    </button>

    <!-- Main Content with Wings -->
    <div class="content-with-wings">
        <!-- Left Wing -->
        <img *ngIf="config.headerLeftIcon" [src]="config.headerLeftIcon" alt="wing-left"
            class="wing-decoration wing-left">

        <!-- Center Content -->
        <div class="center-content">
            <!-- Header -->
            <div class="sub-header">
                <span class="header-text">{{config.headerText}}</span>
            </div>

            <!-- Title -->
            <div class="sub-title">
                <div class="title-badge">
                    <ng-container *ngIf="currentTier === 'tier0'">
                        <span class="title-text">Basic</span>
                    </ng-container>
                    <ng-container *ngIf="currentTier === 'tier1'">
                        <img class="value-icon" src="./assets/imgs/subs_premium_tick.svg" alt="premium tick" >
                        <span class="title-text">Premium</span>
                    </ng-container>
                    <ng-container *ngIf="currentTier === 'tier2'">
                        <img [src]="config.titleIcon" alt="icon" class="title-icon">
                        <span class="title-text">{{config.titleText}}</span>
                    </ng-container>

                </div>
            </div>
        </div>

        <!-- Right Wing -->
        <img *ngIf="config.headerRightIcon" [src]="config.headerRightIcon" alt="wing-right"
            class="wing-decoration wing-right">
    </div>

    <!-- Details Section -->
    <div class="sub-details">
        <div class="detail-row" *ngFor="let detail of details">
            <span class="label">{{detail.label}}</span>
            <span class="value" [ngClass]="detail.valueClass">
                <img *ngIf="detail.icon" [src]="detail.icon" alt="icon" class="value-icon">
                {{detail.value}}
            </span>
        </div>
    </div>

    <!-- Action Button -->
    <button class="action-btn" 
        [class.basic-btn]="currentTier === 'tier0'" 
        [class.pro-commission-background]="currentTier === 'tier2' && isCommission"
        [class.pro-no-commission-background]="currentTier === 'tier2' && !isCommission"
        [class.premium-commission-background]="currentTier === 'tier1' && isCommission"
        [class.premium-no-commission-background]="currentTier === 'tier1' && !isCommission"
        [class.basic-background]="currentTier === 'tier0'"(click)="onButtonClick($event)">
        <span *ngIf="currentTier === 'tier0'">
           Upgrade 
        </span>
        <span *ngIf="currentTier === 'tier1'">
           Upgrade to PRO
        </span>
        <span *ngIf="currentTier === 'tier2'">
            {{config.buttonText}}
        </span>
        <i *ngIf="config.buttonIcon" [class]="config.buttonIcon"></i>
        <i *ngIf="!config.buttonIcon" class="pi pi-arrow-right"></i>
    </button>
</div>